import React, { useContext } from "react";
import "./CartItem.css";
import { ShopContext } from "../../Context/ShopContext";
import remove_icon from "../Assets/cart_cross_icon.png";

const CartItem = () => {
  const { getTotalCartAmount, all_product, cartItem, removeFromCart } =
    useContext(ShopContext);

const handlePayment = async () => {
  // check login first
  const token = localStorage.getItem("auth-token");
  if (!token) {
    alert("Please log in before proceeding to checkout.");
    return; //(no Razorpay popup)
  }

  // Create order from backend
 const order = await fetch("/create-order", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token, // optional if you want backend verification later
    },
    body: JSON.stringify({ amount: getTotalCartAmount() }),
  }).then((res) => res.json());

  // Show Razorpay popup
  const options = {
    key: "rzp_live_RbZp8ZuGovYESs",
    amount: order.amount,
    currency: order.currency,
    name: "SonicWaves",
    description: "Order Payment",
    order_id: order.id,
    handler: async function (response) {
     const verifyRes = await fetch("/verify-payment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(response),
      }).then((res) => res.json());

      alert(verifyRes.message);
    },
    theme: { color: "#3399cc" },
  };

  const rzp1 = new window.Razorpay(options);
  rzp1.open();
};

  return (
    <div className="cartitem">
      <div className="cartitem-format-main">
        <p>Products</p>
        <p>Titles</p>
        <p>Price</p>
        <p>Quantity</p>
        <p>Total</p>
        <p>Remove</p>
      </div>
      <hr />
      {all_product.map((e) => {
        const quantity = cartItem?.[e.id] || 0;
        if (quantity > 0) {
          return (
            <div key={e.id}>
              <div className="cartitem-format cartitem-format-main">
                <img
                  src={e.image}
                  className="carticon-product-icon"
                  alt={e.name}
                />
                <p>{e.name}</p>
                <p>₹{e.price}</p>
                <button className="cartitem-quantity">{quantity}</button>
                <p>₹{e.price * quantity}</p>
                <img
                  src={remove_icon}
                  onClick={() => removeFromCart(e.id)}
                  alt="remove"
                  className="cartitem-remove-icon"
                />
              </div>
              <hr />
            </div>
          );
        }
        return null;
      })}
      <div className="cartitem-down">
        <div className="cartitem-total">
          <h1>Cart total</h1>
          <div>
            <div className="cartitem-total-item">
              <p>Subtotal</p>
              <p>₹{getTotalCartAmount()}</p>
            </div>
            <hr />
            <div className="cartitem-total-item">
              <p>Shipping fee</p>
              <p>Free</p>
            </div>
            <hr />
            <div className="cartitem-total-item">
              <p style={{ fontWeight: 800 }}>Total</p>
              <p>₹{getTotalCartAmount()}</p>
            </div>
          </div>
          <button onClick={handlePayment}>Proceed to Checkout</button>
          <span>NOTE:- Orders placed after 5:00 PM IST will be dispatched the next day. Delivery time may vary depending on your location.</span>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
